export interface ScrollPositionCenter {
    current: number
    top: boolean
    bottom: boolean
}

export interface ScrollPositionLeft {
    current: number
    top: boolean
    bottom: boolean
}

export interface ScrollPositionRight {
    current: number
    top: boolean
    bottom: boolean
}

interface State {
    appDrawer: boolean
    appDrawerIsMin: boolean
    appOverflow: string
    displayPricingBanner: boolean
    scrollPositionLeft: ScrollPositionLeft
    scrollPositionCenter: ScrollPositionCenter
    scrollPositionRight: ScrollPositionRight
}

const defaults = () => {
    return {
        appDrawer: false,      //  Determines if the app navigation drawer is open/close.
        appDrawerIsMin: false,
        appOverflow: 'auto',   //  Sets the overflow property on the app primary content.
        displayPricingBanner: true,
        scrollPositionLeft: {
            current: 0,        //  Holds the current content scroll position for left tri-panel
            top: false,        //  Returns true if the user has scrolled to the top of the content
            bottom: false      //  Returns true of the user has scrolled to the bottom of the content
        },
        scrollPositionCenter: {
            current: 0,        //  Holds the current content scroll position for center tri-panel
            top: false,        //  Returns true if the user has scrolled to the top of the content
            bottom: false      //  Returns true of the user has scrolled to the bottom of the content
        },
        scrollPositionRight: {
            current: 0,        //  Holds the current content scroll position for right page-template
            top: false,        //  Returns true if the user has scrolled to the top of the content
            bottom: false      //  Returns true of the user has scrolled to the bottom of the content
        }
    }
}

export default {
    state: defaults(),
    mutations: {
        appDrawerSet(state: State, bool: boolean): void {
            state.appDrawer = bool
        },
        appDrawerIsMinSet(state: State, bool: boolean): void {
            state.appDrawerIsMin = bool
        },
        appDrawerToggle(state: State): void {
            state.appDrawer = !state.appDrawer
        },
        appLayoutReset(state: State): void {
            Object.assign(state, defaults())
        },
        appOverflowSet(state: State, cssValue: string): void {
            state.appOverflow = cssValue
        },
        closePricingBanner(state: State): void {
            state.displayPricingBanner = false
        },
        scrollPositionLeftSet(state: State, obj: ScrollPositionLeft): void {
            state.scrollPositionLeft = obj
        },
        scrollPositionCenterSet(state: State, obj: ScrollPositionCenter): void {
            state.scrollPositionCenter = obj
        },
        scrollPositionRightSet(state: State, obj: ScrollPositionRight): void {
            state.scrollPositionRight = obj
        }
    },
    actions: {},
    getters: {
        appDrawer(state: State): boolean {
            return state.appDrawer
        },
        appDrawerIsMin(state: State): boolean {
            return state.appDrawerIsMin
        },
        appOverflow(state: State): string {
            return state.appOverflow
        },
        displayPricingBanner(state: State): boolean {
            return state.displayPricingBanner
        },
        scrollPositionLeft(state: State): ScrollPositionLeft {
            return state.scrollPositionLeft
        },
        scrollPositionCenter(state: State): ScrollPositionCenter {
            return state.scrollPositionCenter
        },
        scrollPositionRight(state: State): ScrollPositionRight {
            return state.scrollPositionRight
        }
    }
}